/**
 * Elements marked with `data-aa-back-link` go back to the previous in-site
 * page (preserving scroll position) when possible. If there's no usable
 * referrer, the link's own `href` is used as the fallback.
 */
const initBackLinks = () => {
    const links = document.querySelectorAll('[data-aa-back-link] a, a[data-aa-back-link]');

    links.forEach((link) => {
        link.addEventListener('click', (event) => {
            const referrer = document.referrer;

            if (! referrer) {
                return;
            }

            try {
                const referrerUrl = new URL(referrer);
                if (referrerUrl.origin !== window.location.origin) {
                    return;
                }
            } catch (_) {
                return;
            }

            event.preventDefault();
            window.history.back();
        });
    });
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBackLinks);
} else {
    initBackLinks();
}
